import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Instagram } from 'lucide-react';
import { useCartStore } from '../store/useCartStore';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const {
    items,
    openCart
  } = useCartStore();
  const cartItemsCount = items.reduce((sum, item) => sum + item.quantity, 0);
  return <header className="fixed top-0 left-0 right-0 z-40 bg-white/80 backdrop-blur-md border-b border-gray-100 shadow-sm" data-id="element-31">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center" data-id="element-32">
        <Link to="/" className="text-2xl font-black tracking-tight flex items-center hover:opacity-80 transition-opacity" data-id="element-33">
          <span className="text-brand-yellow font-script italic mr-1" data-id="element-34">My</span>
          <span className="text-brand-blue" data-id="element-35">Planer</span>
        </Link>

        <div className="flex items-center gap-4" data-id="element-36">
          <a href="https://www.instagram.com/myplaner.ua/p/DXq4XE3jJA8/" target="_blank" rel="noopener noreferrer" className="hidden sm:flex items-center gap-2 text-brand-blue font-bold hover:text-brand-blueDark transition-colors bg-brand-bg px-4 py-2 rounded-full text-sm" data-id="element-37">
            <Instagram className="w-4 h-4" data-id="element-38" />
            <span data-id="element-39">@myplaner.ua</span>
          </a>

          <button onClick={openCart} className="relative flex items-center justify-center p-2.5 bg-brand-blue text-white hover:bg-brand-blueDark rounded-full transition-all transform hover:scale-105 shadow-md" data-id="element-40">
            <ShoppingCart className="w-5 h-5" data-id="element-41" />
            <AnimatePresence data-id="element-42">
              {cartItemsCount > 0 && <motion.span initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} exit={{
              scale: 0
            }} className="absolute -top-1.5 -right-1.5 bg-brand-yellow text-brand-blueDark text-xs font-black w-5 h-5 flex items-center justify-center rounded-full border-2 border-white" data-id="element-43">
                  {cartItemsCount}
                </motion.span>}
            </AnimatePresence>
          </button>
        </div>
      </div>
    </header>;
}